import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimaRecodePage } from './pages/AnimaRecode';
import { AHAPage } from './pages/AHA';
import { HomePage } from './pages/Home';
import { DespreMinePage } from './pages/DespreMine';
import { ContactPage } from './pages/Contact';
import { Sesiune1la1Page } from './pages/Sesiune1la1';
import { ResurseGratuitePage } from './pages/ResurseGratuite';
import { AhaAcademyPage } from './pages/AhaAcademy';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col font-sans text-charcoal bg-ivory selection:bg-gold/30 selection:text-charcoal" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Navigate to="/acasa" replace data-id="element-5" />} data-id="element-4" />
          <Route path="/acasa" element={<HomePage data-id="element-7" />} data-id="element-6" />
          <Route path="/despremine" element={<DespreMinePage data-id="element-9" />} data-id="element-8" />
          <Route path="/ahaacademy" element={<AhaAcademyPage data-id="element-11" />} data-id="element-10" />
          <Route path="/animarecode" element={<AnimaRecodePage data-id="element-13" />} data-id="element-12" />
          <Route path="/aha" element={<AHAPage data-id="element-15" />} data-id="element-14" />
          <Route path="/sesiune1la1" element={<Sesiune1la1Page data-id="element-17" />} data-id="element-16" />
          <Route path="/resursegratuite" element={<ResurseGratuitePage data-id="element-19" />} data-id="element-18" />
          <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
          <Route path="*" element={<Navigate to="/acasa" replace data-id="element-23" />} data-id="element-22" />
        </Routes>
      </div>
    </BrowserRouter>;
}